/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the configuration from
// packages/oraclejet-preact/src/resources/icons/themedIcons.config.json
export { View as ViewIcon } from '../../UNSAFE_RedwoodIcons/View';
